import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import EducationalDisclaimer from '@/components/feature/EducationalDisclaimer';

const NevadaVINInspectionPage: React.FC = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <section className="pt-28 pb-12 bg-obsidian-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center space-x-2 text-sm text-obsidian-400 mb-4">
          <Link to="/" className="hover:text-gold-400">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/nevada-dmv-info" className="hover:text-gold-400">DMV Info</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-gold-400">VIN Inspection</span>
        </div>
        <h1 className="font-display text-4xl font-bold text-white mb-3">Nevada VIN Inspection Requirements</h1>
        <p className="text-obsidian-300">When a VIN inspection is required and how to get one in Nevada.</p>
      </div>
    </section>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <EducationalDisclaimer />
      <div className="space-y-8 text-obsidian-700">
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">What Is a VIN Inspection?</h2>
          <p>A Vehicle Identification Number (VIN) inspection verifies that the VIN on the vehicle matches the VIN on the title and other documents. It is required for vehicles being registered in Nevada for the first time to prevent fraud and ensure the vehicle is not stolen.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">When Is a VIN Inspection Required?</h2>
          <ul className="space-y-3">
            {['Vehicles never before registered in Nevada', 'Out-of-state vehicles being registered in Nevada for the first time', 'Vehicles with a rebuilt salvage title', 'Vehicles where the VIN plate appears altered or damaged', 'Certain homemade or kit vehicles'].map(item => (
              <li key={item} className="flex items-start space-x-3 text-sm">
                <i className="ri-checkbox-circle-line text-green-500 flex-shrink-0 mt-0.5"></i><span>{item}</span>
              </li>
            ))}
          </ul>
        </section>
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">VIN Inspection Details</h2>
          <div className="bg-obsidian-50 rounded-xl p-6">
            <table className="w-full text-sm">
              <tbody className="divide-y divide-obsidian-100">
                {[['Fee', '$1.00'], ['Who Can Perform It', 'Nevada DMV representative or peace officer (law enforcement)'], ['Form Used', 'VP 015 (Vehicle Inspection Certificate)'], ['Where to Get One', 'Nevada DMV office or authorized inspection location'], ['Time Required', 'Usually completed same day']].map(([l, a]) => (
                  <tr key={l}><td className="py-2.5 font-medium text-obsidian-700 w-1/3">{l}</td><td className="py-2.5 text-obsidian-600">{a}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
        <div className="bg-gold-50 border border-gold-200 rounded-xl p-6 text-center">
          <h3 className="font-display font-bold text-obsidian-900 text-lg mb-2">Need a VIN Inspection?</h3>
          <p className="text-obsidian-600 text-sm mb-4">Speedy DMV Services can guide you through the VIN inspection process and handle your registration.</p>
          <Link to="/appointment" className="inline-block bg-gold-gradient text-obsidian-900 px-6 py-2.5 rounded-lg font-bold text-sm hover:brightness-110 transition-all whitespace-nowrap">Book Appointment</Link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export default NevadaVINInspectionPage;
